/*

June 17, 2025

*/

export const personas = [
  {
    id: 18,
    title: "The Seeker",
    name: "seeker",
    description: ["Open", "Inquisitive", "Independent"],
    description_txt:
      "You wonder a lot about wonder. You also wonder about why you wonder about wonder.",
    video_filename: "/assets/videos/persona-seeker.mp4",
  },
  {
    id: 22,
    title: "The Naturalist",
    name: "naturalist",
    description: ["Outdoorsy", "Radiant", "Adventurous"],
    description_txt:
      "Your favourite shape is cloud. You have a special voice just for chatting to dogs at the park.",
    video_filename: "/assets/videos/persona-naturalist.mp4",
  },
  {
    id: 17,
    title: "The Powerhouse",
    name: "powerhouse",
    description: ["Strong", "Driven", "Charismatic"],
    description_txt:
      "When you raise an eyebrow, it's seismic. You can win an argument using eye contact alone.",
    video_filename: "/assets/videos/persona-powerhouse.mp4",
  },
  {
    id: 24,
    title: "The Dreamer",
    name: "dreamer",
    description: ["Passionate", "Dedicated", "Impressive"],
    description_txt:
      "The mother of invention calls you 'Mom.' Your favourite colour is banana.",
    video_filename: "/assets/videos/persona-dreamer.mp4",
  },
  {
    id: 23,
    title: "The Connector",
    name: "connector",
    description: ["Outgoing", "Loyal", "Compassionate"],
    description_txt:
      "You are the life of every meditation session. Even die-hard non-huggers feel compelled to hug you.",
    video_filename: "/assets/videos/persona-connector.mp4",
  },
  {
    id: 20,
    title: "The Luminary",
    name: "luminary",
    description: ["Magnetic", "Passionate", "Captivating"],
    description_txt:
      "Strangers have been known to notice you across crowded countries. At night, the stars gaze at you.",
    video_filename: "/assets/videos/persona-luminary.mp4",
  },
  {
    id: 19,
    title: "The Poet",
    name: "poet",
    description: ["Thoughtful", "Empathetic", "Profound"],
    description_txt:
      "You are more than skin deep. You are deep, like, with three e’s. When you gaze into the abyss, you’re able to see the bottom.",
    video_filename: "/assets/videos/persona-poet.mp4",
  },
  {
    id: 21,
    title: "The Muse",
    name: "muse",
    description: ["Stylish", "Alluring", "Tasteful"],
    description_txt:
      "You rearrange pears at the grocery store into still lifes. Your resting face is blue steel.",
    video_filename: "/assets/videos/persona-muse.mp4",
  },
];

export const eras = [
  {
    id: 11,
    name: "Gold",
    image_filename: "era-gold.jpg",
  },
  {
    id: 13,
    name: "Greige",
    image_filename: "era-greige.jpg",
  },
  {
    id: 15,
    name: "Green",
    image_filename: "era-green.jpg",
  },
  {
    id: 12,
    name: "Red",
    image_filename: "era-red.jpg",
  },
  {
    id: 14,
    name: "Blue",
    image_filename: "era-blue.jpg",
  },
];

export const events = [
  // {
  //   id: 3,
  //   name: "David Blackwood: Myth and Legend",
  //   date: "Oct 11, 2025 - July 2026",
  //   description:
  //     "Experience David Blackwood’s enduring vision of Newfoundland through drawings, prints and archival materials.",
  //   event_url: "https://ago.ca/exhibitions/david-blackwood-myth-legend",
  //   image_filename: "night_passage.jpg",
  //   image_artist: "David Blackwood",
  //   image_title: "January Visit Home",
  //   image_copyright: "1975 © Estate of David Blackwood.",
  // },
  {
    id: 3,
    name: "Ranbir Sidhu: No Limits",
    date: "Opens December 11",
    description:
      "An exhibition of monumental sculptures by acclaimed Canadian artist Ranbir Sidhu will transport viewers into a futuristic landscape, alive with Sikh iconography. ",
    event_url: "https://ago.ca/exhibitions/ranbir-sidhu-no-limits",
    image_filename: "odyssey.jpg",
    image_artist: "Ranbir Sidhu",
    image_title: "Odyssey",
    image_copyright: "2025. Rendering courtesy of the artist.",
  },
];

export const artworks = [
  {
    id: "320704",
    image_room: "Gallery 108",
    image_title_artist: "The Queen of Sheba Visiting King Solomon",
    image_artist: "Netherlandish",
    image_title: "Queen of Sheba Visiting King Solomon; Adoration of the Magi",
    image_copyright: "1500-1530. Photo © AGO",
    image_filename:
      "upper_scene_the_queen_of_sheba_visiting_king_solomon_lower_scene_adoration_of_the_magi.jpg",
    persona_name: "The Seeker",
    era_name: "Gold Era",
  },
  {
    id: "653635",
    image_room: "Gallery 146",
    image_title_artist: "Le Penseur by Auguste Rodin",
    image_artist: "Auguste Rodin",
    image_title: "Le Penseur",
    image_copyright: "conceived 1880; cast early 1920s. Photo © AGO",
    image_filename: "le_penseur_by_auguste_rodin.jpg",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "447043",
    image_room: "Gallery 251",
    image_title_artist: "Two Piece Reclining Figure No 2 by Henry Moore ",
    image_artist: "Henry Moore",
    image_title: "Two Piece Reclining Figure No. 2",
    image_copyright: "1960. © The Henry Moore Foundation. Photo: AGO",
    image_filename: "two_piece_reclining_figure_no_2_by_henry_moore.jpg",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "942119",
    image_room: "Gallery 210",
    image_title_artist: "Portrait of Vera by Frederick Horsman Varley",
    image_artist: "Frederick Horsman Varley",
    image_title: "Portrait of Vera",
    image_copyright: "c. 1935. Photo © AGO",
    image_filename: "portrait_of_vera_by_frederick_horsman_varley.jpg",
    persona_name: "The Seeker",
    era_name: "Green Era",
  },
  {
    id: "507580",
    image_room: "Gallery 125",
    image_title_artist: "Vétheuil en été by Claude Monet",
    image_artist: "Claude Monet",
    image_title: "Vétheuil en été",
    image_copyright: "1879. Photo © AGO",
    image_filename: "vetheuil_en_ete_by_claude_monet.jpg",
    persona_name: "The Seeker",
    era_name: "Green Era",
  },
  {
    id: "102010",
    image_room: "Gallery 218",
    image_title_artist: "Winter Afternoon by Lawren S. Harris",
    image_artist: "Lawren S. Harris",
    image_title: "Winter Afternoon City Street, Toronto or Sunday Morning",
    image_copyright: "1918. © Family of Lawren S. Harris. Photo: AGO",
    image_filename: "winter_afternoon_by_lawren_s_harris.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "298862",
    image_room: "Gallery 218",
    image_title_artist:
      "Arctic Peaks, North Shore, Baffin Island by Lawren S. Harris",
    image_artist: "Lawren S. Harris",
    image_title: "Arctic Peaks, North Shore, Baffin Island",
    image_copyright: "1930. © Family of Lawren S. Harris. Photo: AGO",
    image_filename: "arctic_peaks_by_lawren_s_harris.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "786005",
    image_room: "Gallery 218",
    image_title_artist: "South Shore, Bylot Island by Lawren S. Harris",
    image_artist: "Lawren S. Harris",
    image_title: "South Shore, Bylot Island",
    image_copyright: "c. 1931. © Family of Lawren S. Harris. Photo: AGO",
    image_filename: "south_shore_bylot_island_by_lawren_s_harris.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "532175",
    image_room: "Gallery 218",
    image_title_artist: "Emerald Lake, Rocky Mountains by Lawren S. Harris",
    image_artist: "Lawren S. Harris",
    image_title: "Emerald Lake, Rocky Mountains",
    image_copyright: "20th century. © Family of Lawren S. Harris. Photo: AGO",
    image_filename: "emerald_lake_rocky_mountains_by_lawren_s_harris.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  // {
  //   "id": "art011",
  //   "image_room": "Gallery 209",
  //   "image_title_artist": "In Jasper Park by A.Y. Jackson",
  //   "image_artist": "A.Y. Jackson",
  //   "image_title": "In Jasper Park",
  //   "image_copyright": "1924. © Estate of A.Y. Jackson / CARCC, Ottawa (2024). Photo: AGO",
  //   "image_filename": "in_jasper_park_by_ay_jackson.jpg",
  //   "persona_name": "The Naturalist",
  //   "era_name": "Blue Era"
  // },
  // {
  //   "id": "art012",
  //   "image_room": "Gallery 209",
  //   "image_title_artist": "Yellowknife Country by A.Y. Jackson",
  //   "image_artist": "A.Y. Jackson",
  //   "image_title": "Yellowknife Country",
  //   "image_copyright": "1929. © Estate of A.Y. Jackson / CARCC, Ottawa (2024). Photo: AGO",
  //   "image_filename": "yellowknife_country_by_ay_jackson.jpg",
  //   "persona_name": "The Naturalist",
  //   "era_name": "Blue Era"
  // },
  {
    id: "890658",
    image_room: "Gallery 209",
    image_title_artist: "Woodland Tapestry by Franz Johnston",
    image_artist: "Franz Johnston",
    image_title: "Woodland Tapestry, Algoma",
    image_copyright: "1919. Photo © AGO",
    image_filename: "woodland_tapestry_by_franz_johnston.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "546323",
    image_room: "Gallery 209",
    image_title_artist: "Arctic Seas by Frederick Horsman Varley",
    image_artist: "Frederick Horsman Varley",
    image_title: "Arctic Seas",
    image_copyright: "Private Collection. Photo © AGO",
    image_filename: "arctic_seas_by_frederick_horsman_varley.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "958460",
    image_room: "Gallery 209",
    image_title_artist: "Autumn Prelude by Frederick Horsman Varley",
    image_artist: "Frederick Horsman Varley",
    image_title: "Autumn Prelude",
    image_copyright:
      "1938. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename: "autumn_prelude_by_frederick_horsman_varley.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "573583",
    image_room: "Gallery 209",
    image_title_artist: "Summer in the Arctic by Frederick Horsman Varley",
    image_artist: "Frederick Horsman Varley",
    image_title: "Summer in the Arctic",
    image_copyright:
      "c. 1939. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename: "summer_in_the_arctic_by_frederick_horsman_varley.jpg",
    persona_name: "The Naturalist",
    era_name: "Neutral Era",
  },
  {
    id: "812632",
    image_room: "Gallery 210",
    image_title_artist: "Housetops in the Ward by Alfred Joseph Casson",
    image_artist: "Alfred Joseph Casson",
    image_title: "Housetops in the Ward",
    image_copyright:
      "c. 1924. © The Estate of Alfred Joseph Casson. Photo: AGO",
    image_filename: "housetops_in_the_ward_by_alfred_joseph_casson.jpg",
    persona_name: "The Naturalist",
    era_name: "Neutral Era",
  },
  {
    id: "813273",
    image_room: "Gallery 210",
    image_title_artist: "Sumach and Maple by Arthur Lismer",
    image_artist: "Arthur Lismer",
    image_title: "Sumach and Maple, Huntsville",
    image_copyright: "1915. Photo © AGO",
    image_filename: "sumach_and_maple_by_arthur_lismer.jpg",
    persona_name: "The Naturalist",
    era_name: "Red Era",
  },
  {
    id: "316809",
    image_room: "Gallery 210",
    image_title_artist: "Cranberry Lake by Franklin Carmichael",
    image_artist: "Franklin Carmichael",
    image_title: "Cranberry Lake",
    image_copyright: "1931. Photo © AGO",
    image_filename: "cranberry_lake_by_franklin_carmichael.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "470835",
    image_room: "Gallery 210",
    image_title_artist: "Immigrants by Frederick Horsman Varley",
    image_artist: "Frederick Horsman Varley",
    image_title: "Immigrants",
    image_copyright:
      "c. 1922. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename: "immigrants_by_frederick_horsman_varley.jpg",
    persona_name: "The Naturalist",
    era_name: "Red Era",
  },
  {
    id: "758769",
    image_room: "Gallery 210",
    image_title_artist: "Still Life with Apples and Grapes by Paraskeva Clark",
    image_artist: "Paraskeva Clark",
    image_title: "Still Life with Apples and Grapes",
    image_copyright:
      "1935. The Thomson Collection at the Art Gallery of Ontario. © Clive Clark. Photo: AGO",
    image_filename: "still_life_with_apples_and_grapes_by_paraskeva_clark.jpg",
    persona_name: "The Naturalist",
    era_name: "Red Era",
  },
  {
    id: "106576",
    image_room: "Gallery 210",
    image_title_artist: "Light and Shadow by Franklin Carmichael",
    image_artist: "Franklin Carmichael",
    image_title: "Light and Shadow",
    image_copyright: "1937. Photo © AGO",
    image_filename: "light_and_shadow_by_franklin_carmichael.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "724398",
    image_room: "Gallery 216",
    image_title_artist: "Evening Cloud by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Evening Cloud",
    image_copyright:
      "Fall 1915. The Thomson Collection at the Art Gallery of Ontario. Photo Michael Cullen",
    image_filename: "evening_cloud_by_tom_thomson.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "443094",
    image_room: "Gallery 216",
    image_title_artist: "Woodland Interior by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Woodland Interior - Fall",
    image_copyright:
      "1914. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename: "woodland_interior_by_tom_thomson.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "147219",
    image_room: "Gallery 216",
    image_title_artist: "Path Behind Mowat Lodge by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Path Behind Mowat Lodge",
    image_copyright:
      "Spring 1917. The Thomson Collection at the Art Gallery of Ontario. Photo: Michael Cullen",
    image_filename: "path_behind_mowat_lodge_by_tom_thomson.jpg",
    persona_name: "The Naturalist",
    era_name: "Neutral Era",
  },
  {
    id: "816578",
    image_room: "Gallery 216",
    image_title_artist: "Morning Cloud by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Morning Cloud",
    image_copyright:
      "1913. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename: "morning_cloud_by_tom_thomson.jpg",
    persona_name: "The Naturalist",
    era_name: "Neutral Era",
  },
  {
    id: "630009",
    image_room: "Gallery 216",
    image_title_artist: "Northern Lights by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Northern Lights",
    image_copyright:
      "spring 1917. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename: "northern_lights_by_tom_thomson.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "516889",
    image_room: "Gallery 215",
    image_title_artist: "Lake O Hara by J.E.H. MacDonald",
    image_artist: "J.E.H. MacDonald",
    image_title: "Lake O'Hara, Rockies",
    image_copyright: "1926. Photo © AGO",
    image_filename: "lake_o_hara_by_jeh_macdonald.jpg",
    persona_name: "The Naturalist",
    era_name: "Gold Era",
  },
  {
    id: "578112",
    image_room: "Gallery 216",
    image_title_artist: "Maple Saplings, October by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Maple Saplings, October",
    image_copyright: "Winter 1916 or 1917. Photo © AGO",
    image_filename: "maple_saplings_october_by_tom_thomson.jpg",
    persona_name: "The Naturalist",
    era_name: "Gold Era",
  },
  {
    id: "130063",
    image_room: "Gallery 217",
    image_title_artist: "In a Circle by Emily Carr",
    image_artist: "Emily Carr",
    image_title: "In a Circle",
    image_copyright: "1931. Photo © AGO",
    image_filename: "in_a_circle_by_emily_carr.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "820549",
    image_room: "Gallery 133",
    image_title_artist: "The West Wind by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "The West Wind",
    image_copyright: "Winter 1916-1917. Photo © AGO",
    image_filename: "the_west_wind_by_emily_carr.jpg",
    persona_name: "The Naturalist",
    era_name: "Green Era",
  },
  {
    id: "879578",
    image_room: "Gallery 218",
    image_title_artist:
      "Mountains in Snow: Rocky Mountain Paintings VII by Lawren S. Harris",
    image_artist: "Lawren S. Harris",
    image_title: "Mountains in Snow: Rocky Mountain Paintings VII",
    image_copyright:
      "c. 1929. The Thomson Collection at the Art Gallery of Ontario. Photo © AGO",
    image_filename:
      "mountains_in_snow_rocky_mountain_paintings_vii_by_lawren_s_harris.jpg",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "944375",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist: "Saint Paul the Hermit by Mattia Preti",
    image_artist: "Mattia Preti",
    image_title: "Saint Paul the Hermit",
    image_copyright: "c. 1656-1660. Photo © AGO",
    image_filename: "saint_paul_the_hermit_by_mattia_preti.jpg",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "333990",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist: "Jesus at the Pool of Bethesda by Artus Wolfaerts",
    image_artist: "Artus Wolfaerts",
    image_title: "Jesus at the Pool of Bethesda",
    image_copyright: "c. 1620 1630. Photo © AGO",
    image_filename: "jesus_at_the_pool_of_bethesda_by_artus_wolfaerts.jpg",
    persona_name: "The Powerhouse",
    era_name: "Red Era",
  },
  {
    id: "666614",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist:
      "Saint Anne with the Infant Jesus by Georges de La Tour",
    image_artist: "Georges de La Tour",
    image_title: "Saint Anne with the Infant Jesus",
    image_copyright: "c. 1645-1650. Photo © AGO",
    image_filename:
      "saint_anne_with_the_infant_jesus_by_georges_de_la_tour.jpg",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "710796",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist: "The Crucifixion of Saint Andrew by Luca Giordano",
    image_artist: "Luca Giordano",
    image_title: "The Crucifixion of Saint Andrew",
    image_copyright: "c. 1660. Photo © AGO",
    image_filename: "the_crucifixion_of_saint_andrew_by_luca_giordano.jpg",
    persona_name: "The Powerhouse",
    era_name: "Gold Era",
  },
  {
    id: "466080",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist: "Pope Gregory XV by Gian Lorenzo Bernini",
    image_artist: "Gian Lorenzo Bernini",
    image_title: "Pope Gregory XV",
    image_copyright: "1621. Photo © AGO",
    image_filename: "pope_gregory_xv_by_gian_lorenzo_bernini.jpg",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "372908",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist: "Saint Jerome by Angelo Gabriele Pio",
    image_artist: "Angelo Gabriele Pio",
    image_title: "Saint Jerome",
    image_copyright: "first half of the 1700s. Photo © AGO",
    image_filename: "saint_jerome_by_angelo_gabriele_pio.jpg",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "292413",
    image_room: "E.R. Wood Gallery (Gallery 121)",
    image_title_artist: "Virgin Mary Mourning Jesus by Nicolas van der Veken",
    image_artist: "Nicolas van der Veken",
    image_title: "Virgin Mary Mourning Jesus (Pietà)",
    image_copyright: "late 1600s. Photo © AGO",
    image_filename: "virgin_mary_mourning_jesus_by_nicolas_van_der_veken.jpg",
    persona_name: "The Powerhouse",
    era_name: "Gold Era",
  },
  {
    id: "514957",
    image_room: "Walter C. Laidlaw Gallery (Gallery 119)",
    image_title_artist:
      "Cornelis de Vos, Evisceration of a Roebuck with a Portrait of a Married Couple by Frans Snyders",
    image_artist: "Frans Snyders; Cornelis de Vos",
    image_title:
      "Evisceration of a Roebuck with a Portrait of a Married Couple",
    image_copyright: "c. 1625. Photo © AGO",
    image_filename:
      "cornelis_de_vos_evisceration_of_a_roebuck_with_a_portrait_of_a_married_couple_by_frans_snyders.jpg",
    persona_name: "The Powerhouse",
    era_name: "Red Era",
  },
  {
    id: "126970",
    image_room: "Walter C. Laidlaw Gallery (Gallery 119)",
    image_title_artist: "Boy Holding a Torch by Godfried Schalcken",
    image_artist: "Godfried Schalcken",
    image_title: "Boy Holding a Torch",
    image_copyright: "1692. Photo © AGO",
    image_filename: "boy_holding_a_torch_by_godfried_schalcken.jpg",
    persona_name: "The Powerhouse",
    era_name: "Blue Era",
  },
  {
    id: "548163",
    image_room: "Walter C. Laidlaw Gallery (Gallery 119)",
    image_title_artist: "Spring by Leandro Bassano; Gerolamo Bassano",
    image_artist: "Leandro Bassano",
    image_title: "Spring",
    image_copyright: "Mid-16th-early 17th century. Photo © AGO",
    image_filename: "spring_by_leandro_bassano_gerolamo_bassano.jpg",
    persona_name: "The Powerhouse",
    era_name: "Green Era",
  },
  {
    id: "406996",
    image_room: "Walter C. Laidlaw Gallery (Gallery 119)",
    image_title_artist:
      "Still Life with Flowers in a Stoneware Vase by Jan Brueghel",
    image_artist: "Jan Brueghel the Elder",
    image_title: "Still Life with Flowers in a Stoneware Vase",
    image_copyright: "c.1610. Photo © AGO",
    image_filename:
      "still_life_with_flowers_in_a_stoneware_vase_by_jan_brueghel.jpg",
    persona_name: "The Powerhouse",
    era_name: "Red Era",
  },
  {
    id: "398438",
    image_room: "Walter C. Laidlaw Gallery (Gallery 119)",
    image_title_artist: "The Massacre of the Innocents by Peter Paul Rubens",
    image_artist: "Peter Paul Rubens",
    image_title: "The Massacre of the Innocents",
    image_copyright: "c. 1610. Photo © AGO",
    image_filename: "the_massacre_of_the_innocents_by_peter_paul_rubens.jpg",
    persona_name: "The Powerhouse",
    era_name: "Red Era",
  },
  {
    id: "902334",
    image_room: "Gallery 249",
    image_title_artist: "Ram Mask",
    image_artist: "Sorogo peoples",
    image_title: "Ram Mask",
    image_copyright: "early to mid-20th century. Photo © AGO",
    image_filename: "ram_mask.jpg",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "602391",
    image_room: "Gallery 137",
    image_title_artist: "Marchesa Casati by Augustus John",
    image_artist: "Augustus Edwin John",
    image_title: "The Marchesa Casati",
    image_copyright: "1919. © Art Gallery of Ontario",
    image_filename: "marchesa_casati_by_augustus_john.jpg",
    persona_name: "The Powerhouse",
    era_name: "Green Era",
  },
  {
    id: "793025",
    image_room: "Gallery 7",
    image_title_artist: "Two-decker 70 Gun Warship, Edinburgh, Dockyard Model",
    image_artist: "British",
    image_title: "Two-decker 70 Gun Warship, Edinburgh, Dockyard Model ",
    image_copyright: "1721. Photo © AGO",
    image_filename: "two-decker_70_gun_warship_edinburgh_dockyard_model.jpg",
    persona_name: "The Powerhouse",
    era_name: "Gold Era",
  },
  {
    id: "381627",
    image_room: "Gallery 141",
    image_title_artist: "La Demoiselle de magasin by James Tissot",
    image_artist: "James Tissot",
    image_title: "La Demoiselle de magasin",
    image_copyright: "c. 1883-1885. Photo © AGO",
    image_filename: "la_demoiselle_de_magasin_by_james_tissot.jpg",
    persona_name: "The Dreamer",
    era_name: "Neutral Era",
  },
  {
    id: "756459",
    image_room: "Richard Barry Fudger Memorial",
    image_title_artist: "The Tiff by Florence Carlyle",
    image_artist: "Florence Carlyle",
    image_title: "The Tiff",
    image_copyright: "c. 1902. Photo © AGO",
    image_filename: "the_tiff_by_florence_carlyle.jpg",
    persona_name: "The Dreamer",
    era_name: "Neutral Era",
  },
  {
    id: "470500",
    image_room: "Richard Barry Fudger Memorial",
    image_title_artist:
      "Zeuxis choisissant des modèles by Nicolas André Monsiaux",
    image_artist: "Nicolas André Monsiaux",
    image_title: "Zeuxis choisissant des modèles",
    image_copyright: "1797. Photo © AGO",
    image_filename:
      "zeuxis_choisissant_des_modeles_by_nicolas_andre_monsiaux.jpg",
    persona_name: "The Dreamer",
    era_name: "Gold Era",
  },
  {
    id: "645337",
    image_room: "Richard Barry Fudger Memorial",
    image_title_artist:
      "A woman with a spade, seen from behind by Vincent van Gogh",
    image_artist: "Vincent van Gogh",
    image_title: "A woman with a spade, seen from behind",
    image_copyright: "1885. Photo © AGO",
    image_filename:
      "a_woman_with_a_spade_seen_from_behind_by_vincent_van_gogh.jpg",
    persona_name: "The Dreamer",
    era_name: "Green Era",
  },
  {
    id: "326512",
    image_room: "Richard Barry Fudger Memorial",
    image_title_artist: "A Garden in September by Mary Hiester Reid",
    image_artist: "Mary Hiester Reid",
    image_title: "A Garden in September",
    image_copyright: "c. 1894. Photo © AGO",
    image_filename: "a_garden_in_september_by_mary_hiester_reid.jpg",
    persona_name: "The Dreamer",
    era_name: "Green Era",
  },
  {
    id: "441280",
    image_room: "Richard Barry Fudger Memorial",
    image_title_artist: "Les Batteurs de pieux by Maximilien Luce",
    image_artist: "Maximilien Luce",
    image_title: "Les Batteurs de pieux, le chantier",
    image_copyright: "1900. Photo © AGO",
    image_filename: "les_batteurs_de_pieux_by_maximilien_luce.jpg",
    persona_name: "The Dreamer",
    era_name: "Blue Era",
  },
  {
    id: "515587",
    image_room: "Gallery 225",
    image_title_artist: "Landscape by Kazuo Nakamura",
    image_artist: "Kazuo Nakamura",
    image_title: "Landscape",
    image_copyright: "1963. © Art Gallery of Ontario",
    image_filename: "landscape_by_kazuo_nakamura.jpg",
    persona_name: "The Connector",
    era_name: "Blue Era",
  },
  {
    id: "216494",
    image_room: "Wilder Gallery (Gallery 227 & 228)",
    image_title_artist: "The Craft of the Contaminated by Andy Fabo",
    image_artist: "Andy Fabo",
    image_title: "The Craft of the Contaminated",
    image_copyright: "1984. © Art Gallery of Ontario",
    image_filename: "the_craft_of_the_contaminated_by_andy_fabo.jpg",
    persona_name: "The Connector",
    era_name: "Green Era",
  },
  {
    id: "994600",
    image_room: "Wilder Gallery (Gallery 227 & 228)",
    image_title_artist: "Orange by Joanne Tod",
    image_artist: "Joanne Tod",
    image_title: "Orange",
    image_copyright: "1991. © Joanne Tod. Photo: AGO",
    image_filename: "orange_by_joanne_tod.jpg",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "246194",
    image_room: "Wilder Gallery (Gallery 227 & 228)",
    image_title_artist: "Torn Heart by Natalka Husar",
    image_artist: "Natalka Husar",
    image_title: "Torn Heart",
    image_copyright: "1994. © Natalka Husar. Photo: AGO",
    image_filename: "torn_heart_by_natalka_husar.jpg",
    persona_name: "The Connector",
    era_name: "Red Era",
  },
  {
    id: "773744",
    image_room: "Gallery 223",
    image_title_artist: "Moko Jumbie by Zak Ové",
    image_artist: "Zak Ové",
    image_title: "Moko Jumbie",
    image_copyright: "2021. © Zak Ové. Photo: AGO",
    image_filename: "moko_jumbie_by_zak_ove.jpg",
    persona_name: "The Connector",
    era_name: "Gold Era",
  },
  {
    id: "634915",
    image_room: "Gallery 115",
    image_title_artist:
      "Portrait of a Lady with a Lap Dog by Rembrandt van Rijn",
    image_artist: "Rembrandt van Rijn",
    image_title: " Portrait of a Woman with a Lap Dog",
    image_copyright: "c. 1665. Photo © AGO",
    image_filename:
      "portrait_of_a_lady_with_a_lap_dog_by_rembrandt_van_rijn.jpg",
    persona_name: "The Connector",
    era_name: "Red Era",
  },
  {
    id: "611493",
    image_room: "Gallery 117",
    image_title_artist:
      "Christ Washing His Disciples' Feet by Jacopo Tintoretto",
    image_artist: "Jacopo Tintoretto ",
    image_title: "Christ Washing His Disciples' Feet",
    image_copyright: "c. 1545-1555. Photo © AGO",
    image_filename:
      "christ_washing_his_disciples_feet_by_jacopo_tintoretto.jpg",
    persona_name: "The Connector",
    era_name: "Gold Era",
  },
  {
    id: "573269",
    image_room: "Gallery 208",
    image_title_artist: "Reminiscences of Youth by William Kurelek",
    image_artist: "William Kurelek",
    image_title: "Reminiscences of Youth",
    image_copyright:
      "1968. © Estate of William Kurelek, courtesy of the Wynick/Tuck Gallery, Toronto. Photo: AGO",
    image_filename: "reminiscences_of_youth_by_william_kurelek.jpg",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "947218",
    image_room: "Gallery 226",
    image_title_artist: "The Wisdom of the Universe by Christi Belcourt",
    image_artist: "Christi Belcourt",
    image_title: "The Wisdom of the Universe",
    image_copyright: "2014. © Christi Belcourt. Photo: AGO",
    image_filename: "the_wisdom_of_the_universe_by_christi_belcourt.jpg",
    persona_name: "The Connector",
    era_name: "Blue Era",
  },
  {
    id: "893745",
    image_room: "Gallery 200",
    image_title_artist: "The Hunter and the Seamstress by Abraham Anghik Ruben",
    image_artist: "Abraham Anghik Ruben",
    image_title: "The Hunter and the Seamstress",
    image_copyright: "2001. © Abraham Anghik Ruben. Photo: AGO",
    image_filename: "the_hunter_and_the_seamstress_by_abraham_anghik_rube.jpg",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "956402",
    image_room: "Gallery 121 ",
    image_title_artist: "The Toilet of Bathsheba by Luca Giordano",
    image_artist: "Luca Giordano",
    image_title: "The Toilet of Bathsheba",
    image_copyright: "c. 1663. Photo © AGO",
    image_filename: "the_toilet_of__bathsheba_by_luca_giordano.jpg",
    persona_name: "The Poet",
    era_name: "Gold Era",
  },
  {
    id: "908320",
    image_room: "Moments in Modernism Level 4, Gallery 409",
    image_title_artist: "No.1, White and Red by Mark Rothko",
    image_artist: "Mark Rothko",
    image_title: " No.1, White and Red",
    image_copyright:
      "1962. © Kate Rothko Prizel & Christopher Rothko / Artists Rights Society (ARS), New York / CARCC, Ottawa (2024). Photo: AGO",
    image_filename: "no1_white_and_red_by_mark_rothko.jpg",
    persona_name: "The Poet",
    era_name: "Red Era",
  },
  {
    id: "793935",
    image_room: "Moments in Modernism Level 4, Gallery 402",
    image_title_artist: "Victoire by Rita Letendre",
    image_artist: "Rita Letendre",
    image_title: "Victoire [Victory]",
    image_copyright: "1961. © Estate of Rita Letendre. Photo: AGO",
    image_filename: "victoire_by_rita_letendre.jpg",
    persona_name: "The Poet",
    era_name: "Red Era",
  },
  {
    id: "956173",
    image_room: "Gallery 106 (Walker Court) - Two scultpures in one case",
    image_title_artist: "Screaming Faces by Manasiah Akpaliapik",
    image_artist: "Manasiah Akpaliapik",
    image_title: "Screaming Faces",
    image_copyright: "1991. © Manasiah Akpaliapik. Photo: AGO",
    image_filename: "screaming_faces_by_manasiah_akpaliapik.jpg",
    persona_name: "The Poet",
    era_name: "Neutral Era",
  },
  {
    id: "421320",
    image_room: "Gallery 108",
    image_title_artist:
      "The Malmesbury Châsse: The Crucifixion, and Christ in Majesty",
    image_artist: "French (Limoges)",
    image_title:
      "The Malmesbury Châsse: The Crucifixion, and Christ in Majesty",
    image_copyright: "c. 1190-1200. Photo © AGO",
    image_filename:
      "the_malmesbury_chasse_the_crucifixion_and_christ_in_majesty.jpg",
    persona_name: "The Poet",
    era_name: "Gold Era",
  },
  {
    id: "793173",
    image_room: "Gallery 123",
    image_title_artist:
      "Portrait of a Lady Holding an Orange Blossom by Jeremias Schultz",
    image_artist: "Jeremias Schultz",
    image_title: "Portrait of a Lady Holding an Orange Blossom",
    image_copyright: "1770's. Photo © AGO",
    image_filename:
      "portrait_of_a_lady_holding_an_orange_blossom_by_jeremias_schultz.jpg",
    persona_name: "The Muse",
    era_name: "Blue Era",
  },
  {
    id: "857391",
    image_room: "Henry Moore Sculpture Centre (Gallery 251)",
    image_title_artist: "Working Model for Standing Figure by Henry Moore",
    image_artist: "Henry Moore",
    image_title: "Working Model for Standing Figure: Knife Edge",
    image_copyright: "1961. © Henry Moore Foundation. Photo: AGO",
    image_filename: "working_model_for_standing_figure_by_henry_moore.jpg",
    persona_name: "The Muse",
    era_name: "Neutral Era",
  },
  {
    id: "419038",
    image_room: "Henry Moore Sculpture Centre (Gallery 251)",
    image_title_artist: "Reclining Figure by Henry Moore",
    image_artist: "Henry Moore",
    image_title: "Reclining Figure",
    image_copyright: "1956. © Henry Moore Foundation. Photo: AGO",
    image_filename: "reclining_figure_by_henry_moore.jpg",
    persona_name: "The Muse",
    era_name: "Neutral Era",
  },
  {
    id: "190460",
    image_room: "Henry Moore Sculpture Centre (Gallery 251)",
    image_title_artist: "Draped Reclining Woman by Henry Moore",
    image_artist: "Henry Moore",
    image_title: "Draped Reclining Woman",
    image_copyright: "1957-1958. © Henry Moore Foundation. Photo: AGO",
    image_filename: "draped_reclining_woman_by_henry_moore.jpg",
    persona_name: "The Muse",
    era_name: "Neutral Era",
  },
  {
    id: "765685",
    image_room: "Henry Moore Sculpture Centre (Gallery 251)",
    image_title_artist: "Two Piece Reclining Figure No. 9 by Henry Moore",
    image_artist: "Henry Moore",
    image_title: "Two Piece Reclining Figure No. 9",
    image_copyright: "1968. © The Henry Moore Foundation. Photo: AGO",
    image_filename: "two_piece_reclining_figure_no_9_by_henry_moore.jpg",
    persona_name: "The Muse",
    era_name: "Neutral Era",
  },
  {
    id: "146394",
    image_room: "Gallery 127",
    image_title_artist: "Interesting Story by Laura Muntz Lyall",
    image_artist: "Laura Muntz Lyall",
    image_title: "Interesting Story",
    image_copyright: "1898. Photo © AGO. 72/18",
    image_filename: "interesting_story_by_laura_muntz_lyall.jpg",
    persona_name: "The Dreamer",
    era_name: "Neutral Era",
  },
  {
    id: "483669",
    image_room: "Gallery 235",
    image_filename: "sea_captain_figure.jpg",
    image_title_artist: "Sea Captain Figure",
    image_artist: "Haida",
    image_title: "Sea Captain Figure",
    image_copyright: "c. 1840. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "659799",
    image_room: "Gallery 117",
    image_filename:
      "st_john_and_the_two_disciples_of_the_philosopher_craton.jpg",
    image_title_artist:
      "St. John and the Two Disciples of the Philosopher Craton by Master of Foces",
    image_artist: "Master of Foces",
    image_title: "St. John and the Two Disciples of the Philosopher Craton",
    image_copyright: "c. 1300. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "142623",
    image_room: "Gallery 119",
    image_filename: "daedalus_and_icarus.jpg",
    image_title_artist: "Daedalus and Icarus by Anthony van Dyck",
    image_artist: "Anthony van Dyck",
    image_title: "Daedalus and Icarus",
    image_copyright: "c. 1620. Photo © AGO.",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "382279",
    image_room: "Gallery 127",
    image_filename: "the_young_biologist.jpg",
    image_title_artist: "The Young Biologist by Paul Peel",
    image_artist: "Paul Peel",
    image_title: "The Young Biologist",
    image_copyright: "1891. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Gold Era",
  },
  {
    id: "747724",
    image_room: "Gallery 117",
    image_filename: "vision_of_saint_benedict.jpg",
    image_title_artist: "Vision of Saint Benedict by Giovanni del Biondo",
    image_artist: "Giovanni del Biondo",
    image_title: "Vision of Saint Benedict",
    image_copyright: "c. 1375-1399. Photo © AGO.",
    persona_name: "The Seeker",
    era_name: "Blue Era",
  },
  {
    id: "484491",
    image_room: "Gallery 134",
    image_filename: "upward_trend.jpg",
    image_title_artist: "Upward Trend by Emily Carr",
    image_artist: "Emily Carr",
    image_title: "Upward Trend",
    image_copyright: "1937. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Blue Era",
  },
  {
    id: "681224",
    image_room: "Gallery 108",
    image_filename: "the_fall_of_man.jpg",
    image_title_artist: "The Fall of Man by Balthasar Griessmann",
    image_artist: "Balthasar Griessmann",
    image_title: "The Fall of Man",
    image_copyright: "c. 1670-1690. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "322013",
    image_room: "Gallery 220",
    image_filename: "beach_at_st_malo.jpg",
    image_title_artist: "Beach at St. Malo by James Wilson Morrice",
    image_artist: "James Wilson Morrice",
    image_title: "Beach at St. Malo",
    image_copyright: "c. 1903. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Blue Era",
  },
  {
    id: "452926",
    image_room: "Gallery 145",
    image_filename: "the_blue_rocker.jpg",
    image_title_artist: "The Blue Rocker by David Brown Milne",
    image_artist: "David Brown Milne",
    image_title: "The Blue Rocker",
    image_copyright: "1914. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Blue Era",
  },
  {
    id: "368971",
    image_room: "Gallery 204",
    image_filename: "the_jealous_husband.jpg",
    image_title_artist: "The Jealous Husband by Cornelius Krieghoff",
    image_artist: "Cornelius Krieghoff",
    image_title: "The Jealous Husband",
    image_copyright: "c. 1847. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Red Era",
  },
  {
    id: "394857",
    image_room: "Gallery 007",
    image_filename:
      "ship_model_of_an_antique_napoleonic_prisoner_of_war_model.jpg",
    image_title_artist:
      "Ship Model of an Antique Napoleonic Prisoner of War Model",
    image_artist: "Unknown",
    image_title: "Ship Model of an Antique Napoleonic Prisoner of War Model",
    image_copyright: "c.1800. Photo © AGO",
    persona_name: "The Seeker",
    era_name: "Neutral Era",
  },
  {
    id: "636294",
    image_room: "Level 5",
    image_filename: "time_machine_series.jpg",
    image_title_artist: "Time Machine Series by Joyce Wieland",
    image_artist: "Joyce Wieland",
    image_title: "Time Machine Series",
    image_copyright: "© National Gallery of Canada, Ottawa. Photo: AGO",
    persona_name: "The Dreamer",
    era_name: "Blue Era",
  },
  {
    id: "308219",
    image_room: "Gallery 127",
    image_filename: "cows_on_a_hillside.jpg",
    image_title_artist: "Untitled (Cows on a Hillside) by Kathleen Jean Munn",
    image_artist: "Kathleen Jean Munn",
    image_title: "Untitled (Cows on a Hillside)",
    image_copyright: "c. 1916. © Estate of Kathleen Munn",
    persona_name: "The Dreamer",
    era_name: "Red Era",
  },
  {
    id: "165955",
    image_room: "Gallery 116",
    image_filename:
      "the_antique_pottery_painter_sculpturae_vitam_insufflat_pictura.jpg",
    image_title_artist:
      "The Antique Pottery Painter: Sculpturae vitam insufflat pictura by Jean-Léon Gérôme",
    image_artist: "Jean-Léon Gérôme",
    image_title:
      "The Antique Pottery Painter: Sculpturae vitam insufflat pictura",
    image_copyright: "1893. Photo © AGO.",
    persona_name: "The Dreamer",
    era_name: "Neutral Era",
  },
  {
    id: "797952",
    image_room: "Gallery 125",
    image_filename: "the_studio.jpg",
    image_title_artist: "The Studio by Florence Carlyle",
    image_artist: "Florence Carlyle",
    image_title: "The Studio",
    image_copyright: "c. 1902. Photo © AGO",
    persona_name: "The Dreamer",
    era_name: "Neutral Era",
  },
  {
    id: "390504",
    image_room: "Gallery 127",
    image_filename: "the_artists_painting-room.jpg",
    image_title_artist:
      "The Artist's Painting-Room by Mary Ann Rebecca Alabaster",
    image_artist: "Mary Ann Rebecca Alabaster",
    image_title: "The Artist's Painting-Room",
    image_copyright: "1830. Photo © AGO",
    persona_name: "The Dreamer",
    era_name: "Red Era",
  },
  {
    id: "633861",
    image_room: "Gallery 204",
    image_filename: "portrait_of_marie-melanie_quesnel.jpg",
    image_title_artist: "Portrait of Marie-Melanie Quesnel",
    image_artist: "Canadian",
    image_title: "Portrait of Marie-Melanie Quesnel",
    image_copyright: "c. 1810. Photo © AGO",
    persona_name: "The Luminary",
    era_name: "Neutral Era",
  },
  {
    id: "588328",
    image_room: "Gallery 126",
    image_filename: "klingit.jpg",
    image_title_artist: "Klingit by Rita Letendre",
    image_artist: "Rita Letendre",
    image_title: "Klingit",
    image_copyright: "1973. © Estate of Rita Letendre. Photo: AGO",
    persona_name: "The Luminary",
    era_name: "Red Era",
  },
  {
    id: "589791",
    image_room: "Gallery 108",
    image_filename: "death_triumphant.jpg",
    image_title_artist: "Death Triumphant",
    image_artist: "German (Bavaria)",
    image_title: "Death Triumphant",
    image_copyright: "c. 1670. Photo © AGO",
    persona_name: "The Luminary",
    era_name: "Neutral Era",
  },
  {
    id: "554361",
    image_room: "Gallery 115",
    image_filename: "portrait_of_a_seated_woman_with_a_handkerchief.jpg",
    image_title_artist:
      "Portrait of a Seated Woman with a Handkerchief by Rembrandt van Rijn",
    image_artist: "Rembrandt van Rijn",
    image_title: "Portrait of a Seated Woman with a Handkerchief",
    image_copyright: "1644 (?). Photo © AGO",
    persona_name: "The Luminary",
    era_name: "Neutral Era",
  },
  {
    id: "482453",
    image_room: "Gallery 125",
    image_filename: "mrs_wells_as_hebe.jpg",
    image_title_artist: "Mrs. Wells as 'Hebe' by Thomas James Northcote",
    image_artist: "Thomas James Northcote",
    image_title: "Mrs. Wells as 'Hebe'",
    image_copyright: "1805. Photo © AGO",
    persona_name: "The Luminary",
    era_name: "Gold Era",
  },
  {
    id: "809822",
    image_room: "Gallery 114",
    image_filename: "nautilus_cup_and_cover_merman_and_mermaid.jpg",
    image_title_artist:
      "Nautilus Cup and Cover: Merman and Mermaid by Elias Lencker, the elder",
    image_artist: "Elias Lencker, the elder",
    image_title: "Nautilus Cup and Cover: Merman and Mermaid",
    image_copyright: "1591 (with later additions and alterations). Photo © AGO",
    persona_name: "The Connector",
    era_name: "Gold Era",
  },
  {
    id: "161359",
    image_room: "Gallery 205",
    image_filename: "breaking_up_of_a_country_ball_in_canada_early_morning.jpg",
    image_title_artist:
      "Breaking Up of a Country Ball in Canada, Early Morning by Cornelius Krieghoff",
    image_artist: "Cornelius Krieghoff",
    image_title: "Breaking Up of a Country Ball in Canada, Early Morning",
    image_copyright: "1857. Photo © AGO.",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "252248",
    image_room: "Gallery 116",
    image_filename: "la_plage_de_trouville_a_lheure_du_bain.jpg",
    image_title_artist:
      "La plage de Trouville à l'heure du bain by Eugène Boudin",
    image_artist: "Eugène Boudin",
    image_title: "La plage de Trouville à l'heure du bain",
    image_copyright: "1864. Photo © AGO",
    persona_name: "The Connector",
    era_name: "Blue Era",
  },
  {
    id: "222247",
    image_room: "Gallery 221",
    image_filename: "jb_jolifou_aubergiste.jpg",
    image_title_artist: "J.B. Jolifou, Aubergiste by Cornelius Krieghoff",
    image_artist: "Cornelius Krieghoff",
    image_title: "J.B. Jolifou, Aubergiste",
    image_copyright: "1871. Photo © AGO",
    persona_name: "The Connector",
    era_name: "Blue Era",
  },
  {
    id: "347115",
    image_room: "Gallery 204",
    image_filename: "montmorency_falls_in_winter.jpg",
    image_title_artist: "Montmorency Falls in Winter by Joseph Légaré",
    image_artist: "Joseph Légaré",
    image_title: "Montmorency Falls in Winter",
    image_copyright: "1850. Photo © AGO",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "882305",
    image_room: "Gallery 207",
    image_filename: "soldier_and_girl_at_station.jpg",
    image_title_artist: "Soldier and Girl at Station by Alex Colville",
    image_artist: "Alex Colville",
    image_title: "Soldier and Girl at Station",
    image_copyright: "1953. © A.C. Fine Art Inc.",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "457032",
    image_room: "Gallery 202",
    image_filename: "portrait_of_john_budden.jpg",
    image_title_artist: "Portrait of John Budden by Cornelius Krieghoff",
    image_artist: "Cornelius Krieghoff",
    image_title: "Portrait of John Budden",
    image_copyright: "1847. Photo © AGO",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "136489",
    image_room: "Gallery 212",
    image_filename: "pink_billboard.jpg",
    image_title_artist: "Pink Billboard by David Brown Milne",
    image_artist: "David Brown Milne",
    image_title: "Pink Billboard",
    image_copyright: "© Art Gallery of Ontario",
    persona_name: "The Connector",
    era_name: "Blue Era",
  },
  {
    id: "686158",
    image_room: "Gallery 204",
    image_filename: "breaking_lent.jpg",
    image_title_artist:
      "Breaking Lent (or A Friday's Surprise) by Cornelius Krieghoff",
    image_artist: "Cornelius Krieghoff",
    image_title: "Breaking Lent (or A Friday's Surprise)",
    image_copyright: "c. 1847. Photo © AGO",
    persona_name: "The Connector",
    era_name: "Neutral Era",
  },
  {
    id: "725739",
    image_room: "Gallery 108",
    image_filename:
      "double-sided_comb_the_fountain_of_youth_and_the_castle_of_love.jpg",
    image_title_artist:
      "Double-sided Comb: The Fountain of Youth and The Castle of Love",
    image_artist: "Flemish or Italian (Northern)",
    image_title:
      "Double-sided Comb: The Fountain of Youth and The Castle of Love",
    image_copyright: "c. 1450. Photo © AGO",
    persona_name: "The Muse",
    era_name: "Neutral Era",
  },
  {
    id: "510866",
    image_room: "Gallery 116",
    image_filename: "oriental_poppies.jpg",
    image_title_artist: "Oriental Poppies by Laura Muntz Lyall",
    image_artist: "Laura Muntz Lyall",
    image_title: "Oriental Poppies",
    image_copyright: "c. 1915. Photo © AGO",
    persona_name: "The Muse",
    era_name: "Green Era",
  },
  {
    id: "484763",
    image_room: "Gallery 123",
    image_filename: "les_sabots.jpg",
    image_title_artist: "Les Sabots by François Boucher",
    image_artist: "François Boucher",
    image_title: "Les Sabots",
    image_copyright: "1768. Photo © AGO",
    persona_name: "The Muse",
    era_name: "Green Era",
  },
  {
    id: "525682",
    image_room: "Gallery 116",
    image_filename: "etretat_laiguille_et_la_porte_daval.jpg",
    image_title_artist:
      "Étretat, L'Aiguille et la Porte d'Aval by Claude Monet",
    image_artist: "Claude Monet",
    image_title: "Étretat, L'Aiguille et la Porte d'Aval",
    image_copyright: "1885-1886. Photo © AGO",
    persona_name: "The Muse",
    era_name: "Blue Era",
  },
  {
    id: "754776",
    image_room: "Gallery 123",
    image_filename: "jar_of_apricots.jpg",
    image_title_artist: "Jar of Apricots by Jean-Siméon Chardin",
    image_artist: "Jean-Siméon Chardin",
    image_title: "Jar of Apricots",
    image_copyright: "1758. Photo © AGO",
    persona_name: "The Muse",
    era_name: "Neutral Era",
  },
  {
    id: "694748",
    image_room: "Gallery 125",
    image_filename: "iris_bleus_jardin_du_petit_gennevilliers.jpg",
    image_title_artist:
      "Iris bleus, jardin du Petit Gennevilliers by Gustave Caillebotte",
    image_artist: "Gustave Caillebotte",
    image_title: "Iris bleus, jardin du Petit Gennevilliers",
    image_copyright: "c. 1892. Photo © AGO",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "595284",
    image_room: "Gallery 108",
    image_filename: "head_of_a_satyr.jpg",
    image_title_artist: "Head of a Satyr by Walter Pompe",
    image_artist: "Walter Pompe",
    image_title: "Head of a Satyr",
    image_copyright: "1754. Photo © AGO",
    persona_name: "The Naturalist",
    era_name: "Neutral Era",
  },
  {
    id: "114760",
    image_room: "Gallery 202",
    image_filename: "evening_canoe_lake.jpg",
    image_title_artist: "Evening, Canoe Lake by Tom Thomson",
    image_artist: "Tom Thomson",
    image_title: "Evening, Canoe Lake",
    image_copyright: "1915-1916. Photo © AGO",
    persona_name: "The Naturalist",
    era_name: "Blue Era",
  },
  {
    id: "707345",
    image_room: "Gallery 117",
    image_filename: "the_expulsion_of_the_money-changers.jpg",
    image_title_artist:
      "The Expulsion of the Money-Changers by Master of the Kress Epiphany",
    image_artist: "Master of the Kress Epiphany",
    image_title: "The Expulsion of the Money-Changers",
    image_copyright: "c. 1480-1500. Photo © AGO",
    persona_name: "The Powerhouse",
    era_name: "Red Era",
  },
  {
    id: "199753",
    image_room: "Gallery 113",
    image_filename: "chronos_devouring_one_of_his_children.jpg",
    image_title_artist:
      "Chronos Devouring one of his Children by Adam Lenckhardt",
    image_artist: "Adam Lenckhardt",
    image_title: "Chronos Devouring one of his Children",
    image_copyright: "c. 1640. Photo © AGO",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "169669",
    image_room: "Gallery 125",
    image_filename: "louise_jumelin.jpg",
    image_title_artist: "Louise Jumelin by Jean-François Millet",
    image_artist: "Jean-François Millet",
    image_title: "Louise Jumelin",
    image_copyright: "1838. Photo © AGO",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "287491",
    image_room: "Gallery 226",
    image_filename: "portrait_of_mrs_william_henry_boulton.jpg",
    image_title_artist:
      "Portrait of Mrs. William Henry Boulton (Harriet) by George Theodore Berthon",
    image_artist: "George Theodore Berthon",
    image_title: "Portrait of Mrs. William Henry Boulton (Harriet)",
    image_copyright: "1846. Photo © AGO",
    persona_name: "The Powerhouse",
    era_name: "Neutral Era",
  },
  {
    id: "516100",
    image_room: "Gallery 113",
    image_filename: "portrait_of_henry_viii.jpg",
    image_title_artist:
      "Portrait of Henry VIII (1491-1547; reigned 1509-47) by Hans Holbein, the younger",
    image_artist: "Hans Holbein, the younger",
    image_title: "Portrait of Henry VIII (1491-1547; reigned 1509-47)",
    image_copyright: "16th century. Photo © AGO",
    persona_name: "The Powerhouse",
    era_name: "Gold Era",
  },
  {
    id: "431862",
    image_room: "Gallery 200",
    image_filename: "a_work_of_art_in_the_form_of_a_quantity_of_coins.jpg",
    image_title_artist:
      "A work of art in the form of a quantity of coins equal to the number of months of the statistical life expectancy of a child born January 6, 1995 by Micah Lexier",
    image_artist: "Micah Lexier",
    image_title:
      "A work of art in the form of a quantity of coins equal to the number of months of the statistical life expectancy of a child born January 6, 1995",
    image_copyright: "1995. © Micah Lexier. Photo: AGO.",
    persona_name: "The Poet",
    era_name: "Gold Era",
  },
  {
    id: "280235",
    image_room: "Gallery 127",
    image_filename: "trees_in_the_sky.jpg",
    image_title_artist: "Trees in the Sky by Emily Carr",
    image_artist: "Emily Carr",
    image_title: "Trees in the Sky",
    image_copyright: "1939. Photo © AGO",
    persona_name: "The Poet",
    era_name: "Blue Era",
  },
  {
    id: "120125",
    image_room: "Gallery 116",
    image_filename: "mauve_and_gold.jpg",
    image_title_artist: "Mauve and Gold by Marc-Aurèle de Foy Suzor-Côté",
    image_artist: "Marc-Aurèle de Foy Suzor-Côté",
    image_title: "Mauve and Gold",
    image_copyright: "c. 1912. Photo © AGO",
    persona_name: "The Poet",
    era_name: "Gold Era",
  },
  {
    id: "754068",
    image_room: "Gallery 108",
    image_filename: "sleeping_youth.jpg",
    image_title_artist: "Sleeping Youth",
    image_artist: "French",
    image_title: "Sleeping Youth",
    image_copyright: "c. 1220-1230. Photo © AGO",
    persona_name: "The Poet",
    era_name: "Gold Era",
  },
  {
    id: "872984",
    image_room: "Gallery 213",
    image_filename: "yellow_coat_and_shelves.jpg",
    image_title_artist: "Yellow Coat and Shelves by David Brown Milne",
    image_artist: "David Brown Milne",
    image_title: "Yellow Coat and Shelves",
    image_copyright: "June-July 1936. Photo © AGO",
    persona_name: "The Poet",
    era_name: "Neutral Era",
  },
  {
    id: "922814",
    image_room: "Gallery 127",
    image_filename: "i_am_half_sick_of_shadows.jpg",
    image_title_artist:
      "\" 'I am half sick of shadows,'  said The Lady of Shalott\" (Alfred, Lord Tennyson, The Lady of Shalott, Part II) by John William Waterhouse",
    image_artist: "John William Waterhouse",
    image_title:
      "\" 'I am half sick of shadows,'  said The Lady of Shalott\" (Alfred, Lord Tennyson, The Lady of Shalott, Part II)",
    image_copyright: "1915. Photo © AGO.",
    persona_name: "The Poet",
    era_name: "Red Era",
  },
  {
    id: "669809",
    image_room: "Gallery 212",
    image_filename: "black_house_and_garage.jpg",
    image_title_artist: "Black House and Garage by David Milne",
    image_artist: "David Brown Milne",
    image_title: "Black House and Garage",
    image_copyright: "© Art Gallery of Ontario",
    persona_name: "The Poet",
    era_name: "Neutral Era",
  },
  {
    id: "371295",
    image_room: "Gallery 235",
    image_filename: "people_of_the_midnight_sun.jpg",
    image_title_artist: "People of the Midnight Sun by David Ruben Piqtoukun",
    image_artist: "David Ruben Piqtoukun",
    image_title: "People of the Midnight Sun",
    image_copyright: "2017 © David Ruben Piqtoukun. Photo: AGO.",
    persona_name: "The Luminary",
    era_name: "Red Era",
  },
  {
    id: "204186",
    image_room: "Gallery 233",
    image_filename: "collage_by_daphne_odjig.jpg",
    image_title_artist: "Collage by Daphne Odjig",
    image_artist: "Daphne Odjig",
    image_title: "Collage",
    image_copyright: "1969 © Estate of Daphne Odjig",
    persona_name: "The Seeker",
    era_name: "Red Era",
  },
  {
    id: "689470",
    image_room: "Gallery 201",
    image_filename: "talk_of_the_ocean.jpg",
    image_title_artist: "Talk of the Ocean by Surusilutu Ashoona",
    image_artist: "Surusilutu Ashoona",
    image_title: "Talk of the Ocean",
    image_copyright:
      "1980 © Estate of Surusilutu Ashoona. Reproduced with the permission of Dorset Fine Arts. Photo: AGO",
    persona_name: "The Dreamer",
    era_name: "Neutral Era",
  },
  {
    id: "118307",
    image_room: "Gallery 500",
    image_filename: "talk_of_the_ocean.jpg",
    image_title_artist: "Boat Tragedy by Joyce Wieland",
    image_artist: "Joyce Wieland",
    image_title: "Boat Tragedy",
    image_copyright: "1964. © AGO",
    persona_name: "The Poet",
    era_name: "Blue Era",
  },
];

